import { useParams } from 'react-router-dom';

import { TFolder, useFolder } from '@modules/items';
import { StatusLabel } from '@shared/components';
import { useDocumentTitle } from '@shared/hooks';

import ReferenceDetectionContent from '../components/references/ReferenceDetectionContent';
import { TERMINOLOGY } from '@shared/i18n';

const ReferenceDetection = () => {
  const { productId } = useParams();
  const { error, data } = useFolder(productId);

  useDocumentTitle(`${TERMINOLOGY.reference.upper} detection`);

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading workspace..."
      error={error}
      errorMessage="Loading workspace failed!"
      render={(resolvedData) => <ReferenceDetectionContent folder={resolvedData as TFolder} />}
    />
  );
};

export default ReferenceDetection;
